import store from '../../store'

export const permision = {
  /**
   * 登录权限校验
   * @return  Boolean
   */
  auth () {
    return store.getters.isLoggedin
  },
  /**
   * 页面权限判断
   * @return  Boolean
   * @todo
   */
  hasPermision () {
    return true
  }
}

export default permision
